import { RunwayModelsResponse } from '@/types';

export enum WorkflowUpdatable {
    UpdateAutomationSettings = 'UpdateAutomationSettings',
}
export const UPDATE_WORKFLOW_OVERVIEW = 'UPDATE_WORKFLOW_OVERVIEW';
export const CLEAR_WORKFLOW_OVERVIEW = 'CLEAR_WORKFLOW_OVERVIEW';
export const UPDATE_WORKFLOW_STEP_GRAPHS = 'UPDATE_WORKFLOW_STEP_GRAPHS';

export interface UpdateWorkflowOverviewAction {
    type: typeof UPDATE_WORKFLOW_OVERVIEW;
    payload: RunwayModelsResponse['workflowOverview'];
}

export const updateWorkflowOverview = (
    payload: RunwayModelsResponse['workflowOverview'],
): UpdateWorkflowOverviewAction => {
    return {
        type: UPDATE_WORKFLOW_OVERVIEW,
        payload: payload,
    };
};

export interface ClearWorkflowOverviewAction {
    type: typeof CLEAR_WORKFLOW_OVERVIEW;
    payload: {
        appId: string;
    };
}

export const clearWorkflowOverview = (payload: { appId: string }): ClearWorkflowOverviewAction => {
    return {
        type: CLEAR_WORKFLOW_OVERVIEW,
        payload: payload,
    };
};

export interface UpdateWorkflowStepGraphAction {
    type: typeof UPDATE_WORKFLOW_STEP_GRAPHS;
    payload: RunwayModelsResponse['workflowStepGraphs'];
}

export const updateWorkflowStepGraphs = (
    payload: RunwayModelsResponse['workflowStepGraphs'],
): UpdateWorkflowStepGraphAction => {
    return {
        type: UPDATE_WORKFLOW_STEP_GRAPHS,
        payload: payload,
    };
};
